var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMassiveTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4518_1382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.409363 5.87389V1.23607C0.444776 0.527453 1.01578 0.00853333 1.64543 0H6.28324C7.02908 0.0463467 7.91959 0.33876 8.39786 0.878533L15.2626 8.51972C15.6939 9.06561 15.7061 9.82104 15.2626 10.2768L9.88931 15.6501C9.36246 16.1267 8.57638 16.1065 8.13226 15.6501L1.28788 7.98849C0.788936 7.39925 0.416243 6.61145 0.409363 5.87389ZM2.4218 3.19744C2.45104 3.88691 2.99492 4.38449 3.6068 4.39265C4.29826 4.36177 4.79384 3.81064 4.80202 3.19744C4.77158 2.50567 4.21763 2.02047 3.6068 2.01244C2.917 2.04125 2.42979 2.58795 2.4218 3.19744Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4518_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMassiveTag);
export default __webpack_public_path__ + "static/media/icon--massive-tag.3b3e99715415b5c29462eb1322e95f7c.svg";
export { ForwardRef as ReactComponent };